<template lang='pug'>
v-card(style=" background-color: #EEEEEE; padding-left: 20px")
  v-card-title(style='display: block')
    v-row
      v-col(cols='auto')
        h2(v-if="data.event_audit.length > 0" ) {{data.event_audit[0]._source.user.name}}
        h4 {{$t('conversationTimeline.protocol')}} {{userData._source.service_code}}
        h4 {{$t('conversationTimeline.serviceDate')}} {{formatDate(userData._source.start_datetime)}}
        md-button.margin-left.margin-top( @click='generateFile("print")' :disabled='loadingGeneration.print || dialogsGeneration' class='md-sm md-facebook')
          template(v-if='!loadingGeneration.print')
            md-icon(style='font-size: 24px !important;') print
            md-tooltip(md-direction="bottom")
              | {{$t('conversationTimeline.printOut')}}
          template(v-else)
            v-progress-circular(
              size='17',
              width='2',
              style='transition: 0.1s;'
              color='#fff'
              indeterminate)
        md-button.margin-left.margin-top(@click='generateFile("csv")' :disabled='loadingGeneration.csv || dialogsGeneration' class='md-sm md-facebook')
          template(v-if='!loadingGeneration.csv')
            md-icon(style='font-size: 24px !important;') table_view
            md-tooltip(md-direction="bottom")
              | {{$t('conversationTimeline.generateSpreadsheet')}}
          template(v-else)
            v-progress-circular(
              size='17',
              width='2',
              style='transition: 0.1s;'
              color='#fff'
              indeterminate)
        md-button.margin-top(@click='generateFile("pdf")' :disabled='loadingGeneration.pdf || dialogsGeneration' class='md-sm md-facebook' style='margin-right: 0px;')
          template(v-if='!loadingGeneration.pdf')
            md-icon(style='font-size: 24px !important;') picture_as_pdf
            md-tooltip(md-direction="bottom")
              | {{$t('conversationTimeline.exportPdf')}}
          template(v-else)
            v-progress-circular(
              size='17',
              width='2',
              style='transition: 0.1s;'
              color='#fff'
              indeterminate)
        VueJsonToCsv#timeline-csv-component(:json-data='csvData' :csv-title="csvName" :labels='formatedCVSLabels' style='opacity: 0; pointer-events: none;')
      v-col
        v-btn(
          @click='closeTimelineDialog'
          icon
          large
          style='float: right'
        )
          v-icon(large) mdi-close
  PerfectScrollbar(v-if='timelineLoader')
    v-container(style="max-width: 800px; display: block")
      v-timeline(
          dense
          clipped
        )
          v-timeline-item(
            fill-dot
            class="white--text mb-12"
            large
          )
          v-timeline-item(
            v-for=' i in 5'
            :key='i'
            class="mb-4"
            color="#ccc"
            icon-color="grey lighten-2"
            small
          )
            v-skeleton-loader(
              style='width: 30%; background-color: #EEEEEE;'
              type="text@1")
            v-skeleton-loader(
              style='width: 80%; background-color: #EEEEEE;'
              type="text@1")
            v-skeleton-loader(
              style='width: 80%; background-color: #EEEEEE;'
              type="text@1")
             v-skeleton-loader(
              style='width: 80%; background-color: #EEEEEE;'
              type="text@1")
  PerfectScrollbar(v-else)
    v-container(style="max-width: 800px; display: block; justify-content: center")
      v-timeline(
        dense
        clipped
      )
        v-timeline-item(
          fill-dot
          class="white--text mb-12"
          color="#ff9800"
          small
        )
          template(v-slot:icon)
          v-row(justify="space-between")
            v-col(cols="12")
              span {{$t('conversationTimeline.userDataServed')}}&nbsp;
              br
              TitleTimeline(
                :title="$t('conversationTimeline.fullName')"
                :value='userData._source.infos_user.user_name'
              )
              TitleTimeline(
                :title="$t('conversationTimeline.document')"
                :value='userData._source.infos_user.user_id'
              )
              TitleTimeline(
                :title="$t('conversationTimeline.ip')"
                :value='userData._source.infos_user.user_ip'
              )
              TitleTimeline(
                :title="$t('conversationTimeline.totalAttendanceWithTheAssistant')"
                :value='data.service_history.total_not_transfered_to_human'
              )
              TitleTimeline(
                :title="$t('conversationTimeline.totalServiceWithHumanized')"
                :value='data.service_history.total_transfered_to_human'
              )

        v-timeline-item(
          fill-dot
          class="white--text mb-12"
          color="#9c27b0"
          small
          v-if="data.operators.length > 0"
        )
          template(v-slot:icon)
          v-row(justify="space-between" )
            v-col(cols="12")
              div {{$t('conversationTimeline.operatorData')}} &nbsp;
              TitleTimeline(
                :title="$t('conversationTimeline.fullName')"
                :value='data.operators[0].name'
              )
              TitleTimeline(
                :title="$t('conversationTimeline.login')"
                :value='data.operators[0].login'
              )
              TitleTimeline(
                :title="$t('conversationTimeline.ip')"
                :value='data.operators[0].ip'
              )
        v-timeline-item(
          fill-dot
          class="white--text mb-12"
          color="#4caf50"
          small
        )
          template(v-slot:icon)
          v-row(justify="space-between")
            v-col(cols="12")
              div {{$t('conversationTimeline.serviceData')}} &nbsp;
              TitleTimeline(
                :title="$t('conversationTimeline.startDateAndTimeOfService')"
                :value='formatDateTime(data.service_history.start_datetime)'
              )
              TitleTimeline(
                :title="$t('conversationTimeline.endOfCallDateAndTime')"
                :value='formatDateTime(data.service_history.end_datetime)'
              )
              TitleTimeline(
                :title="$t('conversationTimeline.authenticated')"
                :value='data.infos_user.authenticated_type'
              )
              TitleTimeline(
                :title="$t('conversationTimeline.authenticationDateAndTimeOnGovbr')"
                :value='data.service_history.user_auth_time ? formatDateTime(data.service_history.user_auth_time) : "" '
              )
              TitleTimeline(
                :title="$t('conversationTimeline.stamps')"
                :value='data.service_history.user_seals ? data.service_history.user_seals.toString() : "" '
              )

        v-timeline-item(
          v-for='(event, i) in data.event_audit'
          :key='i'
          class="mb-4"
          :color="event._source.module === 'admin' ? '#9c27b0' : '#F44336'"
          icon-color="grey lighten-2"
          small
        )
          template(v-slot:icon)
          v-row(justify="space-between")
            v-col(cols="12")
              div(v-if='i === 0') {{$t('conversationTimeline.conversationAccessHistory')}} &nbsp;
              TitleTimeline(
                :title="$t('conversationTimeline.dateAndTime')"
                :value='formatDateTime(event._source.ts)'
              )
              TitleTimeline(
                :title="$t('conversationTimeline.login')"
                :value='event._source.user.login'
              )
              TitleTimeline(
                :title="$t('conversationTimeline.fullName')"
                :value='event._source.user.name'
              )
              TitleTimeline(
                :title="$t('conversationTimeline.module')"
                :value='event._source.module'
              )

              TitleTimeline(
                :title="$t('conversationTimeline.ip')"
                :value='event._source.user.ip'
              )
              TitleTimeline(
                :title="$t('conversationTimeline.events')"
                :value='mapperEvents(event._source.event)'
              )
</template>

<script>
import Swal from 'sweetalert2'
import jsPDF from 'jspdf'
import 'jspdf-autotable'
import * as moment from 'moment'
import VueJsonToCsv from 'vue-json-to-csv'
import { mapFields } from 'vuex-map-fields'
import { PerfectScrollbar } from 'vue2-perfect-scrollbar'
import TitleTimeline from '../components/TitleTimeline.vue'
import { selectedLocale } from '@/plugins/i18n'
export default {
  props: {
    userData: {
      type: Object,
      required: true
    },
    data: {
      type: Object,
      required: true
    },
    timelineLoader: {
      type: Boolean,
      required: true
    }
  },
  components: {
    VueJsonToCsv,
    PerfectScrollbar,
    TitleTimeline
  },
  data () {
    return {
      loadingGeneration: {
        pdf: false,
        csv: false,
        print: false
      },
      dialogsGeneration: false,
      conversationDialog: false,
      chatData: {},
      chatLoader: false,
      chatInfo: {},
      channelConfig: null,
      progressGeneration: 0,
      endpoint: '',
      filter: {},
      totalTimelineItems: 0,
      csvData: [],
      csvName: null,
      labels: [this.$t('conversationTimeline.dateAndTime'), this.$t('conversationTimeline.login'), this.$t('conversationTimeline.fullName'), this.$t('conversationTimeline.events'), this.$t('conversationTimeline.ip'), this.$t('conversationTimeline.module')]
    }
  },
  computed: {
    ...mapFields('selectedAssistant', ['assistantId']),
    formatedCVSLabels () {
      let csvObjLabels = {}
      this.labels.forEach((label) => {
        csvObjLabels[this.strToSlug(label)] = {
          title: label
        }
      })
      return csvObjLabels
    }
  },
  methods: {
    mapperEvents (event) {
      switch (event) {
        case 'search-conversation':
          return this.$t('conversationTimeline.conversationListing')
        case 'search-interactions':
          return this.$t('conversationTimeline.historyListing')
        case 'search-history' :
          return this.$t('conversationTimeline.serviceHistory')
        case 'print':
          return this.$t('conversationTimeline.print')
        case 'download':
          return this.$t('conversationTimeline.download')
        default:
          return ''
      }
    },
    formatDateTime (date) {
      return moment(date).locale(selectedLocale).format('L LTS')
    },
    formatDate (date) {
      return moment(date).locale(selectedLocale).format('L')
    },
    formatTime (date) {
      return moment(date).locale(selectedLocale).format('LT')
    },
    leadZeros (pad, number) {
      return String(number).padStart(pad, '0')
    },
    statusColor (status) {
      if (status === 'away') {
        return '#ff9800'
      } else if (status === 'busy') {
        return '#F44336'
      } else if (status === 'available') {
        return '#43a047'
      } else {
        return '#969696'
      }
    },
    statusText (status) {
      if (status === 'away') {
        return this.$t('conversationTimeline.absent')
      } else if (status === 'busy') {
        return this.$t('conversationTimeline.occupied')
      } else if (status === 'available') {
        return this.$t('conversationTimeline.available')
      } else if (status === 'offline') {
        return this.$t('conversationTimeline.offline')
      } else {
        return ''
      }
    },
    stateText (state) {
      if (state === 'pending') {
        return this.$t('conversationTimeline.distributed')
      } else if (state === 'attendance') {
        return this.$t('conversationTimeline.attending')
      } else if (state === 'idle') {
        return this.$t('conversationTimeline.idle')
      } else {
        return ''
      }
    },
    formateLabels (event, i) {
      switch (i) {
        case 0:
          return this.formatDateTime(event.ts)
        case 1:
          return event.user.login
        case 2:
          return event.user.name
        case 3:
          return this.mapperEvents(event.event)
        case 4:
          return event.user.ip
        case 5:
          return event.module
        default:
          break
      }
    },
    async openConversationDialog (conversationId) {
      this.conversationDialog = true
      this.chatLoader = true
      try {
        const result = await this.$axios.get(`${process.env.VUE_APP_REPORTS_BACKEND}/interactions`, {
          params: {
            page: 0,
            perPage: 1000,
            conversationId: conversationId
          }
        })
        this.chatData = result.data
        this.chatInfo._id = conversationId
        this.chatInfo._source = {}
      } catch (error) {
      }
      this.chatLoader = false
    },
    closeConversationDialog () {
      this.conversationDialog = false
    },
    closeTimelineDialog () {
      this.$emit('close')
    },
    createHeaderPDF (doc, total) {
      if (this.userData._source.operators?.length > 0) {
        doc.setFontSize(14)
        doc.setFont(undefined, undefined, '700')
        doc.text(15, 10, ` ${this.userData._source.operators[0].name ?? ''}`)
      }

      doc.setFontSize(10)
      doc.setFont('times', undefined, '700')
      doc.text(15, 17, this.$t('conversationTimeline.date'))
      doc.setFont('times', undefined, '300')

      let formattedDate1 = moment(this.userData._source.start_datetime).format('DD/MM/YYYY')
      doc.text(29, 17, `${formattedDate1}`)

      doc.setFontSize(10)
      doc.setFont('times', undefined, '700')
      doc.text(15, 22, this.$t('conversationTimeline.userDataServed'))
      doc.setFont('times', undefined, '300')

      doc.setFont('times', undefined, '700')
      doc.text(15, 27, this.$t('conversationTimeline.fullName:'))
      doc.setFont(undefined, undefined, '300')
      // eslint-disable-next-line camelcase
      doc.text(46, 27, `${this.userData._source.infos_user?.user_name}`)

      doc.setFont('times', undefined, '700')
      doc.text(15, 32, this.$t('conversationTimeline.document:'))
      doc.setFont(undefined, undefined, '300')
      // eslint-disable-next-line camelcase
      doc.text(46, 32, `${this.userData._source.infos_user?.user_id}`)

      doc.setFont('times', undefined, '700')
      doc.text(15, 37, this.$t('conversationTimeline.ip:'))
      doc.setFont(undefined, undefined, '300')
      // eslint-disable-next-line camelcase
      doc.text(46, 37, `${this.userData._source.infos_user?.user_ip}`)

      doc.setFont('times', undefined, '700')
      doc.text(15, 42, this.$t('conversationTimeline.totalAttendanceWithTheAssistant:'))
      doc.setFont(undefined, undefined, '300')
      doc.text(80, 42, `${this.data.service_history.total_not_transfered_to_human}`)

      doc.setFont('times', undefined, '700')
      doc.text(15, 47, this.$t('conversationTimeline.totalServiceWithHumanized:'))
      doc.setFont(undefined, undefined, '300')
      doc.text(82, 47, `${this.data.service_history.total_transfered_to_human}`)

      if (this.data.operators?.length > 0) {
        doc.setFont('times', undefined, '700')
        doc.text(15, 55, this.$t('conversationTimeline.operatorData:'))
        doc.setFont('times', undefined, '700')
        doc.text(15, 60, this.$t('conversationTimeline.fullName:'))
        doc.setFont(undefined, undefined, '300')
        doc.text(42, 60, `${this.data.operators[0].name}`)

        doc.setFont('times', undefined, '700')
        doc.text(15, 65, this.$t('conversationTimeline.login:'))
        doc.setFont(undefined, undefined, '300')
        doc.text(42, 65, `${this.data.operators[0].login}`)

        doc.setFont('times', undefined, '700')
        doc.text(15, 70, this.$t('conversationTimeline.ip:'))
        doc.setFont(undefined, undefined, '300')
        doc.text(42, 70, `${this.data.operators[0].ip}`)
      }

      const tableOffsetY = 80
      return tableOffsetY
    },
    strToSlug (str) {
      str = str.replace(/^\s+|\s+$/g, '') // trim
      str = str.toLowerCase()

      // remove accents, swap ñ for n, etc
      var from = 'ãàáäâẽèéëêìíïîõòóöôùúüûñç·/_,:;'
      var to = 'aaaaaeeeeeiiiiooooouuuunc------'
      for (var i = 0, l = from.length; i < l; i++) {
        str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i))
      }

      str = str.replace(/[^a-z0-9 -]/g, '') // remove invalid chars
        .replace(/\s+/g, '-') // collapse whitespace and replace by -
        .replace(/-+/g, '-') // collapse dashes

      return str
    },
    async generateFile (type) {
      this.totalTimelineItems = this.data.event_audit.length

      try {
        if (type === 'pdf' || type === 'print') {
          let bodyLabels = []
          let labelLine = []
          this.data.event_audit.forEach(event => {
            // if (!this.dialogsGeneration) throw new Error('Cancelado pelo usuário.')
            labelLine = []
            this.labels.forEach((_, index) => {
              labelLine.push(this.formateLabels(event._source, index))
            })
            bodyLabels.push(labelLine)
          })
          // eslint-disable-next-line
          const doc = new jsPDF()
          let offSetY = this.createHeaderPDF(doc, this.totalTimelineItems)

          // if (!this.dialogsGeneration) throw new Error('Cancelado pelo usuário.')
          doc.autoTable({
            startY: offSetY,
            head: [this.labels],
            body: bodyLabels
          })
          // checamos se queremos só o pdf ou também queremos imprimir
          if (type === 'pdf') {
            let timestamp = Date.now()
            doc.save(`${timestamp}_auditoria_${this.userData._source.infos_user.user_name}.pdf`)
          } else if (type === 'print') {
            window.open(doc.output('bloburl'))
          }
        } else if (type === 'csv') {
          let bodyLabels = []
          let lineObject = {}
          this.data.event_audit.forEach(event => {
            // if (!this.dialogsGeneration) throw new Error('Cancelado pelo usuário.')
            this.labels.forEach((element, index) => {
              lineObject[this.strToSlug(element)] = this.formateLabels(event._source, index)
            })
            bodyLabels.push(lineObject)
            lineObject = {}
          })
          this.csvData = bodyLabels
          let timestamp = Date.now()
          this.csvName = `${timestamp}_auditoria_${this.userData._source.infos_user.user_name}`
          this.$nextTick(() => {
            document.querySelector('#timeline-csv-component').click()
          })
        }
      } catch (error) {
        if (error.message === this.$t('conversationTimeline.canceledByUser')) {
          Swal.fire({
            icon: 'error',
            title: this.$t('conversationTimeline.calledOff')
          })
        } else {
          Swal.fire({
            icon: 'error',
            title: this.$t('conversationTimeline.errorGeneratingFile')
          })
        }
      } finally {
        this.dialogsGeneration = false
        this.loadingGeneration[type] = false
        setTimeout(() => {
          this.progressGeneration = 0
        }, 100)
      }
    }
  },
  mounted () {
    if (typeof this.assistantId !== typeof null) {
      let generalConfig = null
      this.$axios.get(`/assistant-configs/${this.assistantId}`)
        .then(response => {
          generalConfig = response.data
          // importing channel config
          if (generalConfig.webclientChannels.length > 0) {
            this.channelConfig = generalConfig.webclientChannels[0]
          } else if (generalConfig.whatsappChannels.length > 0) {
            this.channelConfig = generalConfig.whatsappChannels[0]
          } else if (generalConfig.teamsChannels.length > 0) {
            this.channelConfig = generalConfig.teamsChannels[0]
          } else if (generalConfig.telegramChannels.length > 0) {
            this.channelConfig = generalConfig.telegramChannels[0]
          } else {
            this.channelConfig = null
          }
        })
    }
    this.$nextTick(() => {
      const headers = this.$el.querySelectorAll('th .md-table-head-container .md-table-head-label')

      headers.forEach(el => {
        let title = el.textContent
        el.setAttribute('title', title)
      })
    })
  }
}
</script>

<style>
.v-timeline::before {
  left: 6.6%;
}
</style>
